import { z } from 'zod';
export const CornKernelsSchema = z.object({
    serviceName: z.string(),
    resourceType: z.string(),
    resourceId: z.string(),
});
